import type { KeyboardActionId } from "~/keyboard/actionCatalog";
import type { ShortcutHandler } from "~/keyboard/KeyboardShortcutsContext";

import { useContext, useEffect, useRef } from "react";

import KeyboardShortcutsContext from "~/keyboard/KeyboardShortcutsContext";

interface UseShortcutOptions {
	enabled?: boolean;
}

const useShortcut = (actionId: KeyboardActionId, handler: ShortcutHandler, options?: UseShortcutOptions): void => {
	const { registerShortcut } = useContext(KeyboardShortcutsContext);
	const handlerRef = useRef(handler);
	handlerRef.current = handler;
	const enabled = options?.enabled ?? true;

	useEffect(() => {
		if (!enabled) return;
		return registerShortcut(actionId, (event) => handlerRef.current(event));
	}, [actionId, enabled, registerShortcut]);
};

export default useShortcut;
